import React from 'react';
import { TextInput } from 'junto-ui';
import * as services from './FederalIdInput.services';

const FederalIdInput = ({ value, error, handleError, ...props }) => {
  const errorMessage = services.getErrorMessage(value);
  const hasError = errorMessage || error;

  return (
    <TextInput
      errorMessage={errorMessage || error}
      variant={hasError ? 'error' : 'default'}
      type="tel"
      label="Insira o CNPJ"
      name="federalId"
      placeholder="__.___.___/____-__"
      options={{
        numericOnly: true,
        blocks: [2, 3, 3, 4, 2],
        delimiters: ['.', '.', '/', '-'],
      }}
      value={value}
      {...props}
    />
  );
};

export default FederalIdInput;
